export enum FreshchatPlatform {
  CHAT = 'chat',
  WIDGET = 'widget'
}
